import { between } from './between.rule'
import { email } from './email.rule'
import { required } from './required.rule'
import { max } from './max.rule'
import { min } from './min.rule'
import { dateIsValid } from './date-is-valid.rule'
import { dateMinAge } from './date-min-age.rule'
import { dateNotInFuture } from './date-not-in-future.rule'
import { dateMaxAge } from './date-max-age.rule'
import { charBetween } from './char-between.rule'
import { charMin } from './char-min.rule'
import { charMax } from './char-max.rule'
import type { ValidationRuleConstructor } from '../define-rule'

export type DefaultRule =
  | 'min'
  | 'max'
  | 'between'
  | 'char_between'
  | 'char_min'
  | 'char_max'
  | 'email'
  | 'required'
  | 'date_is_valid'
  | 'date_min_age'
  | 'date_not_in_future'
  | 'date_max_age'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DefaultRules: Readonly<Record<DefaultRule, ValidationRuleConstructor<any>>> =
  Object.freeze({
    min,
    max,
    between,
    char_between: charBetween,
    char_min: charMin,
    char_max: charMax,
    email,
    required,
    date_is_valid: dateIsValid,
    date_min_age: dateMinAge,
    date_not_in_future: dateNotInFuture,
    date_max_age: dateMaxAge
  })

export const DefaultRuleKeys: DefaultRule[] = Object.keys(DefaultRules) as DefaultRule[]
